import { action } from 'satcheljs';

/**
 * Action to set mailbox puid value for user.
 */
const setMailboxPuid = action('setMailboxPuid', (bookingMailboxPuid: string) => ({
    bookingMailboxPuid,
}));

export default setMailboxPuid;
